module.exports = __webpack_public_path__ + "img/14.48baf8cd.jpg";